/**
 * Centralized API Routes
 * 
 * This file exports all CMS API routes with the configured base URL.
 * Use these routes in your API modules for consistent endpoint management.
 * 
 * To change the base URL for deployment:
 * 1. Set VUE_APP_API_URL environment variable in your hosting platform
 * 2. Or modify .env.local file before building
 */

import { apiEndpoints, getApiUrl, API_BASE_URL } from '@/config/api'

// Re-export for convenience
export { apiEndpoints, getApiUrl, API_BASE_URL }

/**
 * Product Routes
 */
export const productRoutes = {
  index: apiEndpoints.products.list,
  featured: apiEndpoints.products.featured,
  show: apiEndpoints.products.detail,
  related: apiEndpoints.products.related,
}

/**
 * Category Routes
 */
export const categoryRoutes = {
  index: apiEndpoints.categories.list,
  show: apiEndpoints.categories.detail,
  products: apiEndpoints.categories.products,
}

/**
 * Inquiry Routes (Contact, Quote, Order)
 */
export const inquiryRoutes = {
  order: apiEndpoints.inquiries.order,
  contact: apiEndpoints.inquiries.contact,
  quote: apiEndpoints.inquiries.quote,
}

/**
 * Settings Routes
 */
export const settingsRoutes = {
  byGroup: apiEndpoints.settings.byGroup,
}

/**
 * Page Routes (CMS Pages)
 */
export const pageRoutes = {
  index: apiEndpoints.pages.list,
  show: apiEndpoints.pages.detail,
}

/**
 * Shop Routes
 */
export const shopRoutes = {
  products: {
    index: apiEndpoints.shopProducts.list,
    featured: apiEndpoints.shopProducts.featured,
    show: apiEndpoints.shopProducts.detail,
    variants: apiEndpoints.shopProducts.variants,
    related: apiEndpoints.shopProducts.related,
  },
  categories: {
    index: apiEndpoints.shopCategories.list,
    show: apiEndpoints.shopCategories.detail,
    products: apiEndpoints.shopCategories.products,
  },
  cart: {
    show: apiEndpoints.cart.show,
    addItem: apiEndpoints.cart.addItem,
    updateItem: apiEndpoints.cart.updateItem,
    removeItem: apiEndpoints.cart.removeItem,
    clear: apiEndpoints.cart.clear,
  },
  wishlist: {
    show: apiEndpoints.wishlist.show,
    addItem: apiEndpoints.wishlist.addItem,
    removeItem: apiEndpoints.wishlist.removeItem,
  },
  checkout: {
    checkout: apiEndpoints.checkout.checkout,
  },
  account: {
    dashboard: apiEndpoints.account.dashboard,
    orders: apiEndpoints.account.orders,
    order: apiEndpoints.account.order,
    profile: apiEndpoints.account.profile,
  },
  search: apiEndpoints.search,
}

/**
 * Authentication Routes
 */
export const authRoutes = {
  register: apiEndpoints.auth.register,
  login: apiEndpoints.auth.login,
  logout: apiEndpoints.auth.logout,
  forgotPassword: apiEndpoints.auth.forgotPassword,
  resetPassword: apiEndpoints.auth.resetPassword,
  refresh: apiEndpoints.auth.refresh,
  me: apiEndpoints.auth.me,
}

/**
 * All routes grouped by resource
 */
export const routes = {
  products: productRoutes,
  categories: categoryRoutes,
  inquiries: inquiryRoutes,
  settings: settingsRoutes,
  pages: pageRoutes,
  shop: shopRoutes,
  auth: authRoutes,
}

export default routes
